export const SUTOCHNO_URL = 'https://cian.sutochno.ru/';

export const SUTOCHNO_DATE_FORMAT = 'yyyy-MM-dd';
